import React from 'react';

import cn from '~/utils/cn';

type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  sm: 'h-[18px] w-[18px]',
  md: 'h-[24px] w-[24px]',
  lg: 'h-[36px] w-[36px]',
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '' }) => {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className={cn(`animate-spin rounded-full border-2 border-current border-t-current/30`, sizeMap[size])}></div>
    </div>
  );
};
